import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

// Lands here after the IdP -> backend exchange: ?token=... -> establish the session.
const SSOCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const run = async () => {
      const p = new URLSearchParams(window.location.search);
      const token = p.get('token');
      const err = p.get('sso_error');
      if (err) return navigate(`/login?sso_error=${err}`, { replace: true });
      if (!token) return navigate('/login?sso_error=no_token', { replace: true });
      try {
        const me = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        login(token, me.data);
        navigate('/portal', { replace: true });
      } catch (e) {
        navigate('/login?sso_error=session_failed', { replace: true });
      }
    };
    run();
  }, [login, navigate]);

  return <div style={{ padding: 60, textAlign: 'center', color: '#8aa0c6' }}>Bezig met inloggen…</div>;
};

export default SSOCallback;
